// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import { FileKind } from "../../../../define/FileKind";
import { UIKind } from "../../../../define/UIKind";
import NormalGameManager from "../../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MilitaryRecruitOfficerLayer extends BasePopUpLayer {
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        O1HD.getModules().uiControlModule.hideLoading();
        utilsView.enterLayerDispose(UIKind.UILayerTag.MilitaryRecruitOfficerLayer, this.node)

        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.bBuyMansion) {
            this.initLayer();
        } else {
            this.openWarnHintLayer();
        }
    }

    initLayer() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.MilitaryRecruitOfficerPopLayer
            , null
            , {
                parent: this
            }
        );
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.MilitaryRecruitOfficerLayer);
    }

    openWarnHintLayer() {
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.EnterLayerEventShow2
            , null
            , {
                parent: this
                , peopleName: '募兵将'
                , peopleIcon: 'spr_zhao_mu_guan'
                , btnName: '离开'
                , sprBg: ''
                , descList: [
                    ['', '这里可是招募校场，不是你想来就能来的地方。等你买了']
                    , ['ffae35', '府邸']
                    , ['', '再来吧，快走开，快走开']
                ]
            }
        );
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
